import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaHome } from "react-icons/fa"; // Corrected import
import "bootstrap/dist/css/bootstrap.min.css";
import { BASE_URL } from "../../constants";

function SheltersCard() {
  const [shelterCount, setShelterCount] = useState(0);
  const [newShelterPercentage, setNewShelterPercentage] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchShelters = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/shelters`);
        const shelters = response.data;

        const totalShelters = shelters.length;

        const oneMonthAgo = new Date();
        oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

        const newShelters = shelters.filter((shelter) => {
          const createdAt = new Date(shelter.createdAt);
          return createdAt >= oneMonthAgo;
        }).length;

        const percentage = ((newShelters / totalShelters) * 100).toFixed(2);

        setShelterCount(totalShelters);
        setNewShelterPercentage(percentage);
      } catch (error) {
        console.error("Error fetching shelters data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchShelters();
  }, []);

  return (
<div
  style={{
    background: "linear-gradient(135deg, #6c757d 0%, #adb5bd 100%)", 
    borderRadius: "12px",
    color: "white",
    padding: "20px", 
    boxShadow: "0px 19px 60px rgb(0 0 0 / 8%)",
  }}
  className="hover-scale w-100"
>
  <div className="card-body p-2">
    <div className="d-flex justify-content-between align-items-center flex-wrap">
      <FaHome
        size={30}
        style={{
          stroke: "white",
          strokeWidth: "10px",
          filter: "drop-shadow(1px 2px 3px rgba(255, 255, 255, 0.5))",
        }}
      />

      <h6
        className="fw-bold mb-1 text-white text-truncate"
        style={{ fontSize: "1.2rem", minWidth: "120px" }}
      >
        {loading ? "..." : `${shelterCount.toLocaleString()} shelters`}
      </h6>
    </div>
    <small
      className="text-white-40 d-block mt-1"
      style={{ fontSize: "0.85rem" }}
    >
      {loading
        ? "..."
        : `(${newShelterPercentage}% ${newShelterPercentage >= 0 ? "↑" : "↓"} From Last Month)`}
    </small>
  </div>
</div>

  
  );
}

export default SheltersCard;